import type { AudioPlayerLabels, VoiceRecorderLabels } from '@packages/chat/ui';

const PLAYBACK_LABELS = {
  play: 'Воспроизвести',
  pause: 'Пауза',
  mute: 'Выключить звук',
  unmute: 'Включить звук',
};

export const AUDIO_PLAYER_LABELS: AudioPlayerLabels = {
  ...PLAYBACK_LABELS,
  loadErrors: {
    unavailable: 'Файл обрабатывается. Попробуйте прослушать его позже.',
    network: 'Не удалось загрузить файл. Проверьте подключение к интернету.',
    decode: 'Не удалось воспроизвести файл.',
  },
};

export const VOICE_RECORDER_LABELS: VoiceRecorderLabels = {
  ...PLAYBACK_LABELS,
  startRecording: 'Начать запись',
  startHint: 'Начните запись',
  stopRecording: 'Остановить запись',
  delete: 'Удалить',
  browserUnsupported: 'Ваш браузер не поддерживает запись голоса.',
  errors: {
    'microphone:denied':
      'Нет доступа к микрофону. Разрешите его в настройках браузера',
    'microphone:notFound': 'Микрофон не найден',
    'microphone:busy': 'Микрофон занят другим приложением',
    'microphone:unknown': 'Не удалось получить доступ к микрофону',
    recordingFailed: 'Запись прервалась. Попробуйте ещё раз',
    unknownMime: 'Не удалось определить тип записи',
  },
};
